// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location[data-v-a98c974c]{margin-right:5px;pointer-events:auto}", ""]);
// Exports
module.exports = exports;
